import BodyDraggable from './BodyDraggable';

export default BodyDraggable;
